import { render, staticRenderFns } from "./FaqFileList.vue?vue&type=template&id=27ebc64c&scoped=true&"
import script from "./FaqFileList.vue?vue&type=script&lang=js&"
export * from "./FaqFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebc64c",
  null
  
)

export default component.exports